import AgTechMetric from '@agtech/web/components/Metrics/AgTechMetric';
import AgTechNoRecordsPage from '@agtech/web/components/Pages/Error/AgTechNoRecordsPage';
import { AgTechMoneyFormatter } from '@agtech/web/utilities/AgTechUtilities';
import _ from 'lodash';
import React from 'react'
import InvoiceGrid from '../components/grids/InvoiceGrid';
import { useInvoiceDataGetPaidInvoicesQuery } from '@sales/data/invoicing/InvoicingDataQueries';
import AgTechQueryLoadingSurface from '@agtech/core/data/queries/AgTechQueryLoadingSurface';

const SaleInvoicePaidInvoicesPage = () => {
    const getPaidInvoicesQuery = useInvoiceDataGetPaidInvoicesQuery();

    return (
        <AgTechQueryLoadingSurface query={getPaidInvoicesQuery}>
            {(paidInvoices) => paidInvoices.length > 0 
                ? (
                    <div className='stretched column-based container'>
                        <div className='tall flexed column-based pr-3 container'>
                            <InvoiceGrid title='Paid Invoices' invoices={paidInvoices} />
                        </div>
                        <div className='tall row-based pl-3 vertical-pane container w-[240px] min-w-[240px]'>
                            <AgTechMetric
                                header='Paid Invoices'
                                value={paidInvoices.length.toString()}
                            />
                            <AgTechMetric
                                header='Total Paid'
                                value={AgTechMoneyFormatter.format(_.sum(paidInvoices.map(invoice => invoice.invoiceTotal)))}
                            />
                        </div>
                    </div>
                ) : (
                    <AgTechNoRecordsPage 
                        message="There are no paid invoices in the system right now."
                        secondaryMessage="Invoice paying can be performed beneath the 'Unpaid Invoices' tab."
                    />
                ) }
        </AgTechQueryLoadingSurface>
    )
}

export default SaleInvoicePaidInvoicesPage;